import Icon from '../components/Icon.vue'

Icon.register({"compass":{"width":512,"height":512,"paths":[{"d":"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM307.4 120.8L204.8 218.6A24-24 0 0 1 198 230.4L164.7 368.1C159 391.6 187.5 407.4 204.6 391.2L307.2 293.4A24-24 0 0 1 314 281.6L347.3 143.9C352.9 120.7 324.7 104.4 307.4 120.8zM256 224C238.3 224 224 238.3 224 256S238.3 288 256 288 288 273.7 288 256 273.7 224 256 224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/compass.js
// module id = null
// module chunks = 